import GlobalStyles from '@mui/material/GlobalStyles';
import { Fragment, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { AppProviders } from './AppProviders';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { RootError } from './components/RootError/RootError';
// import { enableMocking } from './core/msw/enableMocking';
import { initSentry } from './core/sentry/initSentry';

initSentry();

const CHUNK_RELOAD_FLAG = 'odco-chunk-reload';
window.addEventListener('vite:preloadError', event => {
	event.preventDefault();

	if (window.sessionStorage.getItem(CHUNK_RELOAD_FLAG)) return;
	window.sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
	window.location.reload();
});

// Note(Filip): Strict mode causes all `useEffect`s to run twice which causes issues when logging in on localhost because the AWS Cognito magic link carries a token that expires after the first use (in our case the first running of the `useEffect` in the logging context).
const Wrapper =
	import.meta.env.VITE_USE_NEW_AUTH_SERVICE === 'true' ? Fragment : StrictMode;

// Uncomment to enable MSW request mocking against src/core/msw/localHandlers.ts
// (see README.md > "Local Backend Development"). Never commit this uncommented.
// enableMocking().then(() => {
createRoot(document.getElementById('root')!).render(
	<ErrorBoundary fallback={<RootError />}>
		<Wrapper>
			<GlobalStyles
				styles={{
					html: { scrollBehavior: 'smooth' },
					body: { margin: 0 },
					'.mapbox-improve-map': {
						display: 'none !important' // Hide the Mapbox "Improve this map" link
					}
				}}
			/>
			<AppProviders>
				<App />
			</AppProviders>
		</Wrapper>
	</ErrorBoundary>
);
// });
